import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcab() {



    const cardData = {

keyword: "Navi Mumbai Airport Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai Airport Cab services for airport transfers, corporate travel, family trips, local commuting, and outstation journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, flight tracking support, transparent pricing, and doorstep pickup across Navi Mumbai and nearby areas, we ensure a smooth, comfortable, and hassle-free travel experience to and from Navi Mumbai Airport.",

topPlaces: [
    {
        title: "Panvel City",
        description:
            "Panvel is a major connectivity hub near Navi Mumbai Airport known for railway junctions, highways, and rapid urban development, making it a key travel point for airport transfers."
    },
    {
        title: "Kharghar Hills",
        description:
            "Kharghar Hills offer scenic viewpoints, trekking trails, and peaceful surroundings, making them a popular leisure spot near Navi Mumbai for short trips and relaxation."
    },
    {
        title: "Belapur CBD",
        description:
            "CBD Belapur is a major commercial and administrative hub with government offices, corporate centers, and business activity near Navi Mumbai Airport."
    },
    {
        title: "Ulwe Node",
        description:
            "Ulwe is a fast-developing residential and commercial zone close to the upcoming Navi Mumbai Airport, making it a key locality for frequent cab travel."
    },
    {
        title: "Seawoods Grand Central",
        description:
            "Seawoods Grand Central is a modern shopping and lifestyle destination in Navi Mumbai featuring malls, restaurants, and entertainment facilities."
    },
    {
        title: "Nerul Sector Area",
        description:
            "Nerul is a well-developed residential and commercial area in Navi Mumbai known for connectivity, markets, and local travel demand."
    },
    {
        title: "Juinagar Station Area",
        description:
            "Juinagar is an important railway-connected locality in Navi Mumbai, often used for airport transfers and daily commuting."
    },
    {
        title: "Taloja MIDC",
        description:
            "Taloja MIDC is an industrial hub near Navi Mumbai Airport with factories and business centers, frequently used for corporate cab services."
    },
    {
        title: "Palm Beach Road Drive",
        description:
            "Palm Beach Road is a scenic highway in Navi Mumbai offering smooth connectivity, coastal views, and premium driving routes."
    },
    {
        title: "Uran Coastal Region",
        description:
            "Uran is a coastal town near Navi Mumbai Airport known for ports, beaches, and scenic surroundings, making it a growing travel destination."
    }
],



services: [
{
name: "Navi Mumbai Airport Cab",
description: "Mumbai Airport Cab offers Navi Mumbai Airport Cab service for safe, reliable, and comfortable airport transportation across Navi Mumbai and nearby regions. Whether you need airport pickup, airport drop, business transfer, family travel, or late-night ride, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller. Our professional chauffeurs ensure punctual arrival, smooth driving, luggage assistance, and stress-free airport travel experience. With 24x7 availability, real-time booking support, transparent pricing, and doorstep service, we make your airport journey easy and comfortable."
},
{
name: "Navi Mumbai Airport Taxi",
description: "Navi Mumbai Airport Taxi service by Mumbai Airport Cab provides dependable and comfortable taxi solutions for all airport travel needs. Our clean, air-conditioned vehicles and experienced drivers ensure timely pickup and drop, smooth rides, and safe transportation for passengers travelling to or from Navi Mumbai Airport."
},
{
name: "Navi Mumbai Airport Cab Booking",
description: "Navi Mumbai Airport Cab Booking service offers quick and easy online reservation for airport transfers. Mumbai Airport Cab ensures instant confirmation, transparent pricing, multiple vehicle options, and 24x7 booking support for hassle-free travel planning."
},
{
name: "Navi Mumbai Airport Taxi Service",
description: "Navi Mumbai Airport Taxi Service provides reliable transportation for passengers needing airport pickup or drop. We ensure professional chauffeurs, clean vehicles, and punctual service for a smooth and stress-free airport journey."
},
{
name: "Cab to Navi Mumbai Airport",
description: "Cab to Navi Mumbai Airport service offers convenient pickup from your location to the airport with timely arrival and luggage assistance. Mumbai Airport Cab ensures safe and comfortable travel for all passengers."
},
{
name: "Taxi to Navi Mumbai Airport",
description: "Taxi to Navi Mumbai Airport service provides reliable and affordable transportation for airport departures. Mumbai Airport Cab ensures punctual pickup, smooth driving, and comfortable vehicles for stress-free travel."
},
{
name: "Navi Mumbai Airport Drop Cab",
description: "Navi Mumbai Airport Drop Cab service ensures timely and safe drop to the airport for all flight schedules. Mumbai Airport Cab provides professional chauffeurs, real-time route planning, and comfortable rides."
},
{
name: "Navi Mumbai Airport Pickup Cab",
description: "Navi Mumbai Airport Pickup Cab service offers smooth and reliable pickup from the airport to your destination. We ensure flight tracking, luggage assistance, and comfortable travel experience."
},
{
name: "Book Cab for Navi Mumbai Airport",
description: "Book Cab for Navi Mumbai Airport service provides easy booking options for airport transfers. Mumbai Airport Cab ensures quick confirmation, reliable vehicles, and 24x7 customer support for seamless travel."
},
{
name: "Online Cab Booking Navi Mumbai Airport",
description: "Online Cab Booking Navi Mumbai Airport service allows instant booking through digital platforms. Mumbai Airport Cab offers fast confirmation, transparent pricing, and multiple vehicle options for convenience."
},
{
name: "Navi Mumbai Airport Cab Near Me",
description: "Navi Mumbai Airport Cab Near Me service helps you quickly find reliable airport transportation nearby. Mumbai Airport Cab ensures fast pickup, professional drivers, and safe travel experience."
},
{
name: "Cheapest Cab to Navi Mumbai Airport",
description: "Cheapest Cab to Navi Mumbai Airport service offers affordable airport travel without compromising safety or comfort. Mumbai Airport Cab ensures budget-friendly pricing and reliable transportation."
},
{
name: "Best Cab Service Navi Mumbai Airport",
description: "Best Cab Service Navi Mumbai Airport provides premium and reliable airport transportation with experienced chauffeurs and well-maintained vehicles for a smooth travel experience."
},
{
name: "Reliable Airport Cab Navi Mumbai",
description: "Reliable Airport Cab Navi Mumbai service ensures safe, punctual, and professional airport transfers. Mumbai Airport Cab guarantees consistent service quality for all passengers."
},
{
name: "Innova Cab to Navi Mumbai Airport",
description: "Innova Cab to Navi Mumbai Airport service provides spacious and comfortable travel for families and groups. Mumbai Airport Cab ensures smooth rides, luggage space, and professional chauffeurs."
},
{
name: "Ertiga Cab to Navi Mumbai Airport",
description: "Ertiga Cab to Navi Mumbai Airport service offers comfortable 6-7 seater travel for families and small groups. Mumbai Airport Cab ensures safe and affordable airport transfers."
},
{
name: "Sedan Cab to Navi Mumbai Airport",
description: "Sedan Cab to Navi Mumbai Airport service provides economical and comfortable rides for solo and small group travellers. Mumbai Airport Cab ensures timely pickup and smooth travel."
},
{
name: "SUV Cab to Navi Mumbai Airport",
description: "SUV Cab to Navi Mumbai Airport service offers spacious and powerful vehicles for comfortable airport travel. Mumbai Airport Cab ensures safe and reliable transportation."
},
{
name: "Tempo Traveller to Navi Mumbai Airport",
description: "Tempo Traveller to Navi Mumbai Airport service is ideal for large groups and corporate travel. Mumbai Airport Cab ensures ample seating, luggage space, and professional drivers."
},
{
name: "Corporate Cab to Navi Mumbai Airport",
description: "Corporate Cab to Navi Mumbai Airport service is designed for business professionals needing punctual and executive airport transfers. Mumbai Airport Cab ensures premium comfort and reliability."
},
{
name: "Luxury Cab Navi Mumbai Airport",
description: "Luxury Cab Navi Mumbai Airport service offers premium vehicles for high-end airport travel experience. Mumbai Airport Cab ensures comfort, style, and professional chauffeur service."
},
{
name: "Airport Transfer Service Navi Mumbai",
description: "Airport Transfer Service Navi Mumbai provides complete pickup and drop solutions for all airport travel needs. Mumbai Airport Cab ensures punctuality, safety, and comfort."
},
{
name: "Executive Airport Cab Navi Mumbai",
description: "Executive Airport Cab Navi Mumbai service is tailored for corporate and VIP passengers. Mumbai Airport Cab ensures premium vehicles, professional chauffeurs, and timely service."
},
{
name: "Innova Crysta Navi Mumbai Airport Cab",
description: "Innova Crysta Navi Mumbai Airport Cab service offers premium spacious travel for families and business groups. Mumbai Airport Cab ensures comfort, luggage space, and smooth rides."
},
{
name: "Ertiga Cab Navi Mumbai Airport",
description: "Ertiga Cab Navi Mumbai Airport service provides comfortable and budget-friendly airport transfers for small families and groups. Mumbai Airport Cab ensures safe and reliable service."
},
{
name: "Swift Dzire Cab Navi Mumbai Airport",
description: "Swift Dzire Cab Navi Mumbai Airport service offers economical and comfortable rides for solo and small group airport travel. Mumbai Airport Cab ensures timely and smooth service."
},
{
name: "Sedan Cab Navi Mumbai Airport",
description: "Sedan Cab Navi Mumbai Airport service provides affordable and comfortable airport transportation with professional drivers and clean vehicles for hassle-free travel."
},
{
name: "SUV Cab Navi Mumbai Airport",
description: "SUV Cab Navi Mumbai Airport service ensures spacious and safe airport travel for families and groups. Mumbai Airport Cab guarantees comfort and reliability."
},
{
name: "Hyundai Aura Cab Navi Mumbai Airport",
description: "Hyundai Aura Cab Navi Mumbai Airport service offers modern and comfortable sedan travel for airport pickup and drop. Mumbai Airport Cab ensures smooth and economical rides."
}
],

tableData: [
["Navi Mumbai Airport Cab","Navi Mumbai Airport Taxi"],
["Navi Mumbai Airport Cab Booking","Navi Mumbai Airport Taxi Service"],
["Cab to Navi Mumbai Airport","Taxi to Navi Mumbai Airport"],
["Navi Mumbai Airport Pickup Cab","Navi Mumbai Airport Drop Cab"],
["Innova Cab to Navi Mumbai Airport","Ertiga Cab to Navi Mumbai Airport"],
["Sedan Cab to Navi Mumbai Airport","SUV Cab to Navi Mumbai Airport"],
["Tempo Traveller to Navi Mumbai Airport","Corporate Cab to Navi Mumbai Airport"],
["Luxury Cab Navi Mumbai Airport","Executive Airport Cab Navi Mumbai"]
],








whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai Airport Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai Airport Cab services for airport transfers, business travel, family trips, hotel transfers, and outstation transportation requirements."
    },
    {
        WhyChooseheading: "Convenient Airport Pickup and Drop Service",
        WhyChoosedescription: "We offer timely airport pickup and drop facilities to ensure passengers enjoy a smooth, comfortable, and stress-free travel experience."
    },
    {
        WhyChooseheading: "Perfect for Business and Corporate Travelers",
        WhyChoosedescription: "Professionals, executives, and corporate travelers choose our airport cab service for punctual transportation to meetings, offices, hotels, and business destinations."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "Local and Outstation Airport Transfers",
        WhyChoosedescription: "Our services are available for local city travel as well as direct airport transfers to Pune, Nashik, Lonavala, Shirdi, Mahabaleshwar, Surat, and other destinations."
    },
    {
        WhyChooseheading: "Flight Monitoring for Timely Service",
        WhyChoosedescription: "Our team monitors flight schedules and adjusts pickup timings accordingly to ensure seamless service even during flight delays."
    },
    {
        WhyChooseheading: "Professional Drivers and Safe Travel",
        WhyChoosedescription: "Our experienced chauffeurs ensure safe driving, route expertise, punctual service, and customer satisfaction throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From solo travelers and families to corporate teams and tourist groups, we provide suitable airport transportation for every requirement."
    }
]
};

const faqData = [
    {
        question: "What is Navi Mumbai Airport Cab Service?",
        answer: "Navi Mumbai Airport Cab Service provides airport pickup and drop transportation for passengers traveling to and from Navi Mumbai International Airport."
    },
    {
        question: "Can I pre-book a cab for Navi Mumbai Airport?",
        answer: "Yes, customers can pre-book airport cabs in advance to ensure timely pickup and hassle-free travel."
    },
    {
        question: "Which vehicles are available for airport transfers?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and premium vehicles are available."
    },
    {
        question: "Do you provide airport pickup and drop services?",
        answer: "Yes, we provide both airport pickup and drop services for domestic and international travelers."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many companies and business professionals use our airport cab services for executive transportation and corporate travel."
    },
    {
        question: "Are Tempo Travellers available for group airport transfers?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, tourist groups, and corporate teams."
    },
    {
        question: "Do drivers track flight arrival timings?",
        answer: "Yes, flight schedules are monitored to ensure timely pickups even if flights are delayed or rescheduled."
    },
    {
        question: "Can I book a cab from Navi Mumbai Airport to outstation destinations?",
        answer: "Yes, customers can directly travel from Navi Mumbai Airport to Pune, Nashik, Shirdi, Lonavala, Mahabaleshwar, Surat, and many other destinations."
    },
    {
        question: "Is advance booking recommended for airport transfers?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth airport transportation."
    },
    {
        question: "How can I book a Navi Mumbai Airport Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Vivek Shah",
        feedback:
            "My airport pickup was perfectly coordinated despite a delayed flight. The driver was waiting on arrival, and the journey was smooth and comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Radhika Kulkarni",
        feedback:
            "We booked an airport transfer for our family and were extremely satisfied with the service. The vehicle was clean, spacious, and the driver was very professional.",
        rating: 5
    }
];





























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-airport-cab.jpg",
"description": "Book Navi Mumbai Airport cab service for reliable airport transfers, pickup, and drop services. Mumbai Airport Cabs offers comfortable taxis with professional drivers, 24x7 availability, and smooth connectivity to and from Navi Mumbai Airport.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/navi-mumbai-airport-cab"
}
};



    return (
        <div>




<Helmet>
  <title>Navi Mumbai Airport Cab | Airport Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport cab for reliable pickup and drop service. Safe and comfortable airport taxi with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="navi mumbai airport cab, navi mumbai airport taxi, navi mumbai airport cab booking, navi mumbai airport taxi service, cab to navi mumbai airport, taxi to navi mumbai airport"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaiairportcab;